module.exports = __webpack_public_path__ + "img/miniPro_judai_prolist.6e43f540.png";